/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { apiRequest } from "../../../../common/common";
import { showNotification } from "../../../../common/Notification/ToastifyNotification";
import { LoadingPage } from "../../../../common/LoadingPage";
import { Autocomplete, Box, CircularProgress, Divider, FormControl, Grid, InputLabel, OutlinedInput, styled, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from "@mui/material";
import CommonTree from "./CommonTree";
import { buildTree, getAllNodeIds, getNormalData } from "../../../../common/const";
import { useSelector } from "react-redux";

const Cell = styled(TableCell)({
    padding: '10px',
    fontWeight: 'bold',
});

const CommonDestination = ({
    projectData,
    setProjectData,
    room,
    level,
    department,
    tableData,
    setTableData,
    fromCatalog,
    innerLabel,
    displayDestination,
    isMove,
    selectedData
}) => {
    const { user } = useSelector(state => state.users);
    const [dataLoading, setDataLoading] = useState(false);
    const [project, setProject] = useState(null);
    const [checked, setChecked] = useState([level?.level_id || department?.department_id || room?.room_id]);
    const [expanded, setExpanded] = useState([]);
    const [initialData, setInitialData] = useState([]);
    const [projectArr, setProjectArr] = useState([]);
    const [projectLoading, setProjectLoading] = useState(false);
    const [isProjectAvailabe, setIsProjectAvailable] = useState(false);
    const [projectPage, setProjectPage] = useState(1);
    const [projectId, setProjectId] = useState((innerLabel !== 'Department' || !isMove) ? projectData?.project_id : null);

    const getData = async () => {
        const url = [
            `/project/details/${projectData?.project_id}`
        ].filter(Boolean).join('&');
        setDataLoading(true);
        try {
            const response = await apiRequest('get', `${url}`);
            const { data } = response.data;
            setExpanded(getAllNodeIds(buildTree(data, innerLabel, selectedData, isMove)));
            setInitialData(getNormalData(data, innerLabel));
            setProject(data);
            setDataLoading(false);
        } catch (error) {
            setDataLoading(false);
            showNotification(error?.response?.data.error || error.message, 'error');
        }
    }

    useEffect(() => {
        if (projectData?.project_id && (!isMove || innerLabel !== 'Department')) {
            getData();
        }
    }, [projectData, isMove]);

    useEffect(() => {
        const dataArr = [];
        if (checked.length > 0 && checked?.[0] !== undefined && initialData?.length > 0) {
            checked.map((a) => {
                if (innerLabel === 'Department') {
                    if (initialData.find((c) => c.level_id === a)) {
                        dataArr.push(initialData.find((c) => c.level_id === a));
                        setTableData(dataArr);
                    }
                } else if (innerLabel === 'Room') {
                    if (initialData.find((c) => c.department_id === a)) {
                        dataArr.push(initialData.find((c) => c.department_id === a));
                        setTableData(dataArr);
                    }
                } else {
                    if (initialData.find((c) => c.room_id === a)) {
                        dataArr.push(initialData.find((c) => c.room_id === a));
                        setTableData(dataArr);
                    }
                }
                return a;
            });
        } else {
            setTableData([]);
        }
    }, [checked, initialData]);

    const getProjectData = async (pageNo, searchText) => {
        try {
            setProjectLoading(true);
            const response = await apiRequest('get', `/project/list/${user?.organization?.organization_id}?pageNo=${pageNo}&pageSize=100&${searchText ? `searchText=${searchText}` : ''}`);
            const { data } = response.data;
            if (data?.length > 0) {
                setIsProjectAvailable(true);
                const array = [...projectArr, ...data];
                const uniqueArray = [
                    ...new Set(
                        array.map((item) => JSON.stringify(item)),
                    ),
                ].map((item) => JSON.parse(item));
                if (isMove && innerLabel === 'Department') {
                    setProjectArr(uniqueArray.filter((a) => a.project_id !== projectData?.project_id));
                } else {
                    setProjectArr(uniqueArray);
                }
                setProjectLoading(false);
            } else {
                setProjectLoading(false);
            }
        } catch (error) {
            setProjectLoading(false);
            showNotification(error?.response?.data.error || error.message, 'error');
        }
    }

    useEffect(() => {
        if (fromCatalog) {
            getProjectData(projectPage);
        }
    }, [fromCatalog]);

    const loadNextProject = async (event) => {
        const listBoxNode = event.currentTarget;
        const numberOfPages = projectPage + 1;
        const position = listBoxNode.scrollTop + listBoxNode.clientHeight;
        if (listBoxNode.scrollHeight - position <= 1 && isProjectAvailabe) {
            setProjectPage(numberOfPages);
            await getProjectData(numberOfPages);
        }
    };

    const getIndividualProject = async () => {
        try {
            setDataLoading(true);
            const response = await apiRequest('get', `/project/${projectId}`);
            const { data } = response.data;
            if (data) {
                if (setProjectData) {
                    setProjectData(data);
                }
                setTableData([]);
                setDataLoading(false);
            }
        } catch (error) {
            setDataLoading(false);
            showNotification(error?.response?.data.error || error.message, 'error');
        }
    }

    useEffect(() => {
        if (projectId) {
            getIndividualProject();
        }
    }, [projectId]);

    return (
        <>
            {dataLoading && (<LoadingPage isLoading={dataLoading} />)}
            <Grid container spacing={1} mt={0.1}>
                <Grid item xs={12} sm={6} md={3} lg={3} style={{ height: '70vh', overflow: 'auto', borderRight: '1px solid lightgray' }}>
                    {fromCatalog && (
                        <>
                            <Box m={1}>
                                <Autocomplete
                                    value={projectArr.find((c) => c.project_id === projectId) || null}
                                    id="combo-box-demo"
                                    size="small"
                                    fullWidth
                                    clearIcon={null}
                                    options={projectArr}
                                    disabled={isMove}
                                    getOptionLabel={(option) => option?.name}
                                    ListboxProps={{
                                        onScroll: (event) => loadNextProject(event),
                                    }}
                                    onChange={async (event, newValue) => {
                                        setProjectId(newValue?.project_id);
                                        if (isMove && innerLabel === 'Department') {
                                            const url = [
                                                `/project/details/${newValue?.project_id}`
                                            ].filter(Boolean).join('&');
                                            setDataLoading(true);
                                            try {
                                                const response = await apiRequest('get', `${url}`);
                                                const { data } = response.data;
                                                setExpanded(getAllNodeIds(buildTree(data, innerLabel)));
                                                setInitialData(getNormalData(data, innerLabel));
                                                setProject(data);
                                                setDataLoading(false);
                                            } catch (error) {
                                                setDataLoading(false);
                                                showNotification(error?.response?.data.error || error.message, 'error');
                                            }
                                        }

                                    }}
                                    onInputChange={(e) => {
                                        if (e) {
                                            if (e?.target?.value?.length >= 1) {
                                                setProjectArr([]);
                                                setProjectPage(1);
                                                getProjectData(1, e?.target?.value);
                                            }
                                        }
                                    }}
                                    renderInput={(params) =>
                                        <TextField
                                            fullWidth
                                            {...params}
                                            label="Select Project"
                                            name="Select Project"
                                            variant="outlined"
                                            InputProps={{
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <>
                                                        {projectLoading ? <CircularProgress color="primary" size={20} /> : null}
                                                        {params.InputProps.endAdornment}
                                                    </>
                                                ),
                                            }}
                                        />}
                                />
                            </Box>
                            <Divider />
                        </>
                    )}
                    {project?.project_id && (
                        <CommonTree
                            nodes={buildTree(project, innerLabel, selectedData, isMove)}
                            checked={checked}
                            setChecked={setChecked}
                            expanded={expanded}
                            setExpanded={setExpanded}
                        />)}
                </Grid>
                {(!displayDestination) && (
                    <Grid item xs={12} sm={6} md={9} lg={9} style={{ paddingRight: '10px' }}>
                        <Typography style={{ fontWeight: 'bold' }}>Choose/Review Destination(s)</Typography>
                        <Typography variant="body2">Validate where you are placing the items and in what quantity per room for selected item</Typography>
                        <Box sx={{ width: '100%', overflowX: 'auto', border: '1px solid lightgrey', marginTop: 1 }}>
                            <TableContainer>
                                <Table sx={{ minWidth: 650 }} aria-label="responsive table">
                                    <TableHead>
                                        <TableRow>
                                            <Cell>Quantity</Cell>
                                            <Cell>Project Name</Cell>
                                            <Cell>Department Name</Cell>
                                            <Cell>Room Name</Cell>
                                            <Cell>Room Number</Cell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {tableData.map((a) => (
                                            <TableRow>
                                                <TableCell>
                                                    <FormControl size="small" fullWidth variant="outlined">
                                                        <InputLabel htmlFor="standard-adornment-password">Quantity</InputLabel>
                                                        <OutlinedInput
                                                            label="Quantity"
                                                            id="Quantity"
                                                            type='number'
                                                            value={a?.quantity || null}
                                                            sx={{
                                                                width: '100px'
                                                            }}
                                                            onChange={(e) => {
                                                                setTableData((prevData) => {
                                                                    return prevData.map((item) =>
                                                                        item.room_id === a.room_id
                                                                            ? { ...item, quantity: Number(e.target.value) }
                                                                            : item
                                                                    );
                                                                });
                                                            }}
                                                        />
                                                    </FormControl>
                                                </TableCell>
                                                <TableCell>
                                                    {a?.project_name}
                                                </TableCell>
                                                <TableCell>
                                                    {a?.department_name}
                                                </TableCell>
                                                <TableCell>
                                                    {a?.room_name}
                                                </TableCell>
                                                <TableCell>
                                                    {a?.room_no || '--'}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    </Grid>
                )}
                {displayDestination && (
                    <Grid item xs={12} sm={6} md={9} lg={9} style={{ paddingRight: '10px' }}>
                        <Typography style={{ fontWeight: 'bold' }}>{displayDestination ? 'Destination' : 'Choose/Review Destination(s)'}</Typography>
                        <Typography variant="body2">{displayDestination ? 'Where would you like to copy the selected Items?' : 'Validate where you are placing the items and in what quantity per room for selected item'}</Typography>
                        <Box sx={{ width: '100%', overflowX: 'auto', border: '1px solid lightgrey', marginTop: 1 }}>
                            <TableContainer>
                                <Table sx={{ minWidth: 650 }} aria-label="responsive table">
                                    <TableHead>
                                        <TableRow>
                                            <Cell>Project Name</Cell>
                                            <Cell>Building Name</Cell>
                                            <Cell>Level Name</Cell>
                                            {(innerLabel === 'Room' || innerLabel === 'Item') && (
                                                <Cell>Department Name</Cell>
                                            )}
                                            {innerLabel === 'Item' && (
                                                <Cell>Room Name</Cell>
                                            )}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {tableData.map((a) => (
                                            <TableRow>
                                                <TableCell>
                                                    {a?.project_name}
                                                </TableCell>
                                                <TableCell>
                                                    {a?.building_name}
                                                </TableCell>
                                                <TableCell>
                                                    {a?.level_name}
                                                </TableCell>
                                                {(innerLabel === 'Room' || innerLabel === 'Item') && (
                                                    <TableCell>
                                                        {a?.department_name}
                                                    </TableCell>
                                                )}
                                                {innerLabel === 'Item' && (
                                                    <TableCell>{a.room_name}</TableCell>
                                                )}
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    </Grid>
                )}
            </Grid>
            <Divider />
        </>
    )
};

export default CommonDestination;